export default {
    success: 'Le véhicule a été soumis à Torque avec succès',
    warning: {
        activixPutFailed:
            'Une erreur du côté de Torque est survenue, veuillez contacter le support.',
        blocked: "L'utilisateur est inactif ou bloqué",
        dealerNotFound: 'Concessionaire introuvable',
        invalidRequestPayload: 'Les données de la requête sont invalides',
        invalidRequest: "Envoie invalide, informations sur le véhicule ou l'utilisateur manquantes",
        notFound: 'Utilisateur introuvable',
        noToken: "Ce Concessionaire n'est pas autorisé à exporter un lead",
    },
    tooltip: {
        match: "La soumission du véhicule vers Torque est basée sur la marque, le modèle, l'année et l'odomètre. Assurez-vous que les valeurs entrées soient valides avant la soumission",
        niv: "Vous devez saisir un NIV valide afin d'avoir une soumission valide vers Torque",
        unsubmitted: 'Soumettre le véhicule vers Torque',
        missingAdvisor: 'Un conseiller est requis pour soumettre le véhicule vers Torque',
        inactiveAdvisor: 'Le conseiller doit être actif pour soumettre le véhicule vers Torque',
    },
};
